import React from 'react';
import {createRoot} from 'react-dom/client';

import App from './App';
import './app/prototype';
import {BrowserRouter} from "react-router-dom";
import {RecoilRoot} from "recoil";
import {QueryClient, QueryClientProvider} from "react-query";

const container = document.getElementById('root');
const root = createRoot(container!);

console.log('route test', 'EmployeeDetail.tsx');

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1, //재시도 횟수 - default 3
            staleTime: 100,
        },
    }
});

root.render(
    <RecoilRoot>
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </BrowserRouter>
    </RecoilRoot>
);
